import { CasinoGame, CasinoGameSeoContext } from "../../http/protocol";
import { SingleTargetSeoDraft, SingleTargetSeoServiceType } from "./singleTargetSeoDraft";

/** The part of the casino game service the draft loads and saves through. */
export type CasinoGameSeoServiceType = SingleTargetSeoServiceType<CasinoGameSeoContext>;

/** The SEO values being edited for one casino game, sent once the game itself is saved. */
export class CasinoGameSeoDraft extends SingleTargetSeoDraft<CasinoGameSeoContext> {
  saveAfterGameSave(savedGame: CasinoGame): Promise<void> {
    return this.saveAfterTargetSave(savedGame.id);
  }

  /** The fallbacks are derived from the game's own fields, so they change whenever the game is saved. */
  refreshFallbacksAfterGameSave(savedGame: CasinoGame): Promise<void> {
    return this.reloadContext(savedGame.id);
  }
}
